import createNamespaceContext from './helper/createNamespaceContext';
export var NOTIFICATIONS_CONTEXT = 'NotificationsCtx';
export var NotificationsAnalyticsContext = createNamespaceContext(NOTIFICATIONS_CONTEXT, 'NotificationsAnalyticsContext');